module.exports = __webpack_public_path__ + "app/img/logo-map.901580db.svg";